import React, { useState } from "react"
import { Button, Input, Popconfirm } from "antd"
import { PoweroffOutlined, CheckCircleOutlined } from "@ant-design/icons"

const InactiveExecutor = ({ rowData, mainProps }) => {
  const [des, setDes] = useState(rowData.inactiveDes)
  const isInactive = rowData.inactive

  return (
    <Popconfirm
      title={isInactive ? "فعال کردن مجری" : "غیرفعال کردن مجری"}
      description={
        <Input.TextArea
          rows={3}
          value={des}
          onChange={e => setDes(e.target.value)}
          placeholder="توضیح"
        />
      }
      onConfirm={() =>
        mainProps.onInactiveExecutor({
          exeId: rowData.id,
          inactive: !rowData.inactive,
          des,
        })
      }
      okText={isInactive ? "فعال شود" : "غیرفعال شود"}
      cancelText="بستن"
      placement="left"
      icon={null}
    >
      <Button
        size="small"
        type={isInactive ? "default" : "primary"}
        danger={!isInactive}
        icon={isInactive ? <CheckCircleOutlined /> : <PoweroffOutlined />}
        style={{ borderRadius: 6, minWidth: 36 }}
      />
    </Popconfirm>
  )
}

export default InactiveExecutor
